/**
 * RCC Pipeline Module - Enhanced Pipeline System with Integrated Tracing
 * RCC流水线模块 - 带有集成跟踪的增强流水线系统
 */

// Enhanced base modules
export { PipelineBaseModule, PipelineModuleConfig } from './modules/PipelineBaseModule';

// Debuggable pipeline module
export {
  DebuggablePipelineModule,
  DebuggablePipelineModuleConfig,
  ExecutionOptions,
  ExecutionResult,
  ExecutionMetrics,
  TraceSummary
} from './core/DebuggablePipelineModule';

// Core execution context system
export {
  PipelineExecutionContext,
  ExecutionContextFactory,
  ExecutionContextOptions,
  ModuleInfo,
  PipelineStage,
  ExecutionError,
  ExecutionStatistics
} from './core/PipelineExecutionContext';

// Framework classes
export { default as BaseProvider } from './framework/BaseProvider';

// Module discovery and assembly
export { ModuleScanner, ProviderDiscoveryOptions } from './framework/ModuleScanner';
export { PipelineAssembler, AssemblerConfig, AssemblyResult } from './framework/PipelineAssembler';

// Scheduling system
export { Pipeline } from './framework/Pipeline';
export { PipelineFactory } from './framework/PipelineFactory';
export { PipelineScheduler } from './framework/PipelineScheduler';
export { VirtualModelSchedulerManager } from './framework/VirtualModelSchedulerManager';

// Pipeline tracking
export { PipelineTracker } from './framework/PipelineTracker';

// Error types
export {
  ErrorCategory,
  ErrorSeverity,
  TraceEventType,
  EnhancedErrorInfo,
  TraceEvent,
  IErrorHandler,
  IPerformanceMetrics
} from './types/ErrorTypes';

// OpenAI interface
export * from './framework/OpenAIInterface';

// Qwen provider
export { default as QwenProvider } from './providers/qwen';

// iFlow provider
export { default as IFlowProvider } from './providers/iflow';

// Version info
export const version = '1.0.0';
export const name = 'OpenAI Compatible Providers Framework';